// The reads the demo screen composes its views from: the ordinary user and company listings plus
// the one thing no existing endpoint carries, which users the importer created.
import { admin_list_seeded_user_ids, get_companies, get_users } from "../../api";
import type { Company, User } from "../../api/types";

export type Directory = {
  users: User[];
  companies: Company[];
  seeded: Set<string>;
};

export const loadDirectory = async (): Promise<Directory> => {
  const [users, companies, seeded] = await Promise.all([
    get_users(),
    get_companies(),
    admin_list_seeded_user_ids(),
  ]);
  return { users: users.items, companies: companies.items, seeded: new Set(seeded) };
};
